"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Annotation = /** @class */ (function () {
    function Annotation(ctx) {
        this.labelOptions = {};
        this.lineOptions = {};
        this.ctx = ctx;
        var _a = this.ctx, classPrefix = _a.classPrefix, root = _a.root, id = _a.id;
        this.group = root
            .append("g")
            .attr("class", classPrefix + "-chart-annotation")
            .attr("data-z-index", "6")
            .attr("clip-path", "url(#" + id + ")")
            .attr("transform", "translate(0, 0)");
        this.labels = this.group
            .append("g")
            .attr("class", classPrefix + "-chart-annotation-labels")
            .attr("transform", "translate(0, 0)");
        this.shapes = this.group
            .append("g")
            .attr("class", classPrefix + "-chart-annotation-shapes")
            .attr("transform", "translate(0, 0)");
    }
    Annotation.prototype.label = function (key, cfg) {
        this.labelOptions[key] = cfg;
        return this;
    };
    Annotation.prototype.line = function (key, cfg) {
        this.lineOptions[key] = cfg;
        return this;
    };
    Annotation.prototype.draw = function () {
        var _this = this;
        clearTimeout(this.drawTimer);
        this.drawTimer = setTimeout(function () {
            _this.shapes.selectAll("g").remove();
            _this.labels.selectAll("g").remove();
            Object.values(_this.labelOptions).forEach(function (cfg) {
                _this.drawLabels(cfg);
            });
            Object.values(_this.lineOptions).forEach(function (cfg) {
                _this.drawLines(cfg);
            });
        }, 10);
    };
    Annotation.prototype.drawLabels = function (cfg) {
        var _this = this;
        var classPrefix = this.ctx.classPrefix;
        var label = this.labels
            .append("g")
            .attr("class", classPrefix + "-chart-label " + classPrefix + "-chart-annotation-label");
        var position = cfg.position, content = cfg.content, offsetX = cfg.offsetX, offsetY = cfg.offsetY, textStyle = cfg.textStyle;
        var _a = tslib_1.__read(position || [], 2), _b = _a[0], x = _b === void 0 ? 0 : _b, _c = _a[1], y = _c === void 0 ? 0 : _c;
        label
            .append("text")
            .attr("text-anchor", "middle")
            .attr("style", replaceSVGStyleToHTML(textStyle))
            .attr("transform", function () {
            var width = _this.ctx.getPlotWidth();
            var height = _this.ctx.getPlotHeight();
            var xPos = typeof x === "number" ? x : (parseFloat(x) / 100) * width;
            var yPos = typeof y === "number" ? y : (parseFloat(y) / 100) * height;
            return "translate(" + xPos + "," + yPos + ")";
        })
            .attr("dx", offsetX)
            .attr("dy", offsetY)
            .append("tspan")
            .text(content);
    };
    Annotation.prototype.drawLines = function (cfg) {
        var classPrefix = this.ctx.classPrefix;
        var line = this.shapes
            .append("g")
            .attr("class", classPrefix + "-chart-annotation-line");
        var _a = cfg.start, start = _a === void 0 ? [] : _a, _b = cfg.end, end = _b === void 0 ? [] : _b, _c = cfg.style, style = _c === void 0 ? {} : _c, _d = cfg.text, text = _d === void 0 ? {} : _d;
        var _e = tslib_1.__read(start, 2), _f = _e[0], x1 = _f === void 0 ? 0 : _f, _g = _e[1], y1 = _g === void 0 ? 0 : _g;
        var _h = tslib_1.__read(end, 2), _j = _h[0], x2 = _j === void 0 ? 0 : _j, _k = _h[1], y2 = _k === void 0 ? 0 : _k;
        var _l = style.stroke, stroke = _l === void 0 ? "#bbbbbb" : _l, _m = style.lineDash, lineDash = _m === void 0 ? [] : _m, lineWidth = style.lineWidth;
        var content = text.content, _o = text.textStyle, textStyle = _o === void 0 ? "" : _o, _p = text.position, position = _p === void 0 ? "start" : _p, _q = text.offsetX, offsetX = _q === void 0 ? 0 : _q, _r = text.offsetY, offsetY = _r === void 0 ? 0 : _r, _s = text.textAnchor, textAnchor = _s === void 0 ? "start" : _s;
        line
            .append("line")
            .attr("x1", x1)
            .attr("y1", y1)
            .attr("x2", x2)
            .attr("y2", y2)
            .attr("stroke", stroke)
            .attr("stroke-width", lineWidth)
            .attr("stroke-dasharray", lineDash.join(","));
        if (content) {
            var label = this.labels
                .append("g")
                .attr("class", classPrefix + "-chart-label " + classPrefix + "-chart-annotation-label");
            label
                .append("text")
                .attr("text-anchor", textAnchor)
                .attr("style", replaceSVGStyleToHTML(textStyle))
                .attr("transform", function () {
                if (position === "end") {
                    return "translate(" + x2 + "," + y2 + ")";
                }
                if (position === "center") {
                    var offsetX_1 = Math.abs(x2 - x1) / 2;
                    var offsetY_1 = Math.abs(y2 - y1) / 2;
                    return "translate(" + (x1 + offsetX_1) + "," + (y1 + offsetY_1) + ")";
                }
                return "translate(" + x1 + "," + y1 + ")";
            })
                .attr("dx", offsetX)
                .attr("dy", offsetY)
                .append("tspan")
                .text(content);
        }
    };
    return Annotation;
}());
exports.Annotation = Annotation;
function replaceSVGStyleToHTML(style) {
    return style
        .replace(/color:/, "fill:")
        .replace(/background-color:/, "stroke");
}
//# sourceMappingURL=annotation.js.map